/*

Lalitha 10/27/2022 3225736869 night jobs UX changes
Ashraf 12/16/2022 3225736869 fixed role based access

*/
import React, {useEffect, useState} from 'react';
import NightJobSearch from './NightJobSearch';
import {ResetStatus as resetStatus} from '../../../../../redux/reducers/NightJobs/AddNightJob';
import {useDispatch} from 'react-redux';

const SearchNightJobContainer = ({setTabValue, setValue, setBreCode, setNightJobCode, setIsCopyRowData, setJobCode, setSelected}) => {
  const dispatch = useDispatch();

  const [selectedRows, setSelectedRows] = useState([]);
  const [searchData, setSearchData] = useState({});
  useEffect(() => {
    dispatch(resetStatus());
    setIsCopyRowData(false);
  }, []);

  return (
    <>
      <NightJobSearch
        setTabValue={setTabValue}
        setValue={setValue}
        setJobCode={setJobCode}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        searchData={searchData}
        setSearchData={setSearchData}
        setBreCode={setBreCode}
        setNightJobCode={setNightJobCode}
        setIsCopyRowData={setIsCopyRowData}
        setSelected={setSelected}
      />
    </>
  );
};
export default SearchNightJobContainer;
